import Vue from 'vue'
import VueRouter from 'vue-router'
/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// 路由懒加载
const Login = () => import('../views/Login.vue')
const Index = () => import('../views/Index.vue')
// 数据报表
const DataReport = () => import('../views/dataReport/dataReport.vue')
// 店铺装修storedecoration
const storeDecoration = () => import('../views/storedecoration/storedecoration.vue')
// 店铺装修-页面管理
const decorationPageManage = () => import('../views/storedecoration/decorationPage.vue')
// 店铺装修-导航设置
const shopnavManage = () => import('../views/storedecoration/shopnavManage.vue')
// 店铺装修-个人中心设置
const userMyManage = () => import('../views/storedecoration/userMyManage.vue')

const Product = () => import('../views/product/Product.vue')
const ProductCategory = () => import('../views/productCategory/ProductCategory.vue')
const employeemangent = () => import('../views/auth/employeeMangement/employeemangent.vue')
const employeeDetail = () => import('../views/auth/employeeMangement/employeeDetail.vue')
const roleMangent = () => import('../views/auth/roleInfo/roleMangent.vue')
const roleDetail = () => import('../views/auth/roleInfo/roleDetail.vue')
const ScoreConfig = () => import('../views/scoreConfig/scoreConfig.vue') // 积分配置
const MemberScoreRecords = () => import('../views/memberScoreRecords/MemberScoreRecords.vue')
const PointsStatistics = () => import('../views/pointsStatistics/pointsStatistics.vue')
const ScoreOrder = () => import('../views/scoreOrder/scoreOrder.vue') // 积分订单
const ProductScore = () => import('../views/productScore/ProductScore.vue')
const Coupon = () => import('../views/coupon/Coupon.vue')
const SeckillProduct = () => import('../views/seckillProduct/SeckillProduct.vue')
const Order = () => import('../views/order/Order.vue')
const Review = () => import('../views/review/Review.vue')

const OrderItemStatisticsList = () => import('../views/orderItemStatisticsList/orderItemStatisticsList.vue')
const Productmallaftersales = () => import('../views/productmallaftersales/productmallaftersales.vue')
const Member = () => import('../views/member/Member.vue')


const MemberInvoice = () => import('../views/memberInvoice/MemberInvoice.vue')
const MemberStoreCard = () => import('../views/memberStoreCard/MemberStoreCard.vue')
const SupplierAccountInfo = () => import('../views/supplierAccountInfo/SupplierAccountInfo.vue')
// 商家管理
const MerchantBaseInfo = () => import('../views/merchantBaseInfo/MerchantBaseInfo.vue')


Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/index' },
  { path: '/login', component: Login },
  {
    path: '/index',
    component: Index,
    redirect: '/dataReport',
    children: [
      { path: '/index', component: DataReport },
      // 店铺装修storedecoration shopnavManage userMyManage
      { path: '/storedecoration', component: storeDecoration },
      { path: '/decorationPageManage', component: decorationPageManage },
      { path: '/shopnavManage', component: shopnavManage },
      { path: '/userMyManage', component: userMyManage },
      { path: '/employeemangent', component: employeemangent },
      { path: '/employeeDetail', component: employeeDetail },
      { path: '/roleMangent', component: roleMangent },
      { path: '/roleDetail', component: roleDetail },

      { path: '/product', component: Product },
      { path: '/productCategory', component: ProductCategory },
      { path: '/productSupplier', component: () => import('../views/productSupplier/ProductSupplier.vue') },
      { path: '/addProduct', component: () => import('../views/product/addProduct.vue') },


      //营销活动管理
      { path: '/productActivity', component: () => import('../views/productActivity/ProductActivity.vue') },
      { path: '/memberScoreRecords', component: MemberScoreRecords },
      { path: '/scoreConfig', component: ScoreConfig },
      { path: '/pointsStatistics', component: PointsStatistics },
      { path: '/scoreOrder', component: ScoreOrder },
      { path: '/productScore', component: ProductScore },
      { path: '/coupon', component: Coupon },
      { path: '/seckillProduct', component: SeckillProduct },
      { path: '/order', component: Order },
      { path: '/review', component: Review },
      { path: '/mallaftersales', component: Productmallaftersales },
      { path: '/orderItemStatisticsList', component: OrderItemStatisticsList },
      { path: '/member', component: Member },
      { path: '/memberInvoice', component: MemberInvoice },
      { path: '/memberStoreCard', component: MemberStoreCard },
      { path: '/addSeckillProduct', component: () => import('../views/seckillProduct/addSeckillProduct.vue') },
      {path: '/activityList', component: () => import('../views/activityList/activityList.vue')},
      {path: '/kdniaoConfig', component: () => import('../views/kdniaoConfig/kdniaoConfig.vue')},
      { path: '/supplierAccountInfo', component: SupplierAccountInfo },
      {path: '/vipLevelConfig',component: () => import('../views/vipLevelConfig/vipLevelConfig.vue') },

      { path: '/merchantBaseInfo', component: MerchantBaseInfo },
    ]

  }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = '' // token保存在localstorage中

    let item = localStorage.getItem('token')
    // 先将拿到的试着进行json转为对象的形式
    try {
      item = JSON.parse(item)
    } catch (error) {
      // eslint-disable-next-line no-self-assign
      item = item
    }
    if (item && item.startTime) {
      let date = new Date().getTime()
      // 如果大于就是过期了，如果小于或等于就还没过期
      let timel = date - item.startTime
      console.log('timelength:' + timel + ',expires:' + item.expires)
      if (timel < item.expires) {
        token = item.value
      }
    }
    if (token === null || token === '') {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
